class ProductInfoTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab]');
    this.panels = this.querySelectorAll('[data-panel]');

    if (this.tabs.length === 0 || this.panels.length === 0) {
      return;
    }

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
      tab.addEventListener('keydown', this.handleKeyDown.bind(this));

      const panelId = `panel-${tab.dataset.tab}`;
      const panel = this.querySelector(`[data-panel="${tab.dataset.tab}"]`);

      if (panel) {
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', tab.classList.contains('active') ? 'true' : 'false');
        tab.setAttribute('tabindex', tab.classList.contains('active') ? '0' : '-1');

        panel.setAttribute('id', panelId);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', `tab-${tab.dataset.tab}`);
        panel.setAttribute('aria-hidden', tab.classList.contains('active') ? 'false' : 'true');
      }
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const targetPanel = clickedTab.dataset.tab;

    this.switchTab(clickedTab, targetPanel);
  }

  handleKeyDown(event) {
    const tabsArray = Array.from(this.tabs);
    const currentIndex = tabsArray.indexOf(event.currentTarget);

    let targetIndex = currentIndex;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        targetIndex = (currentIndex + 1) % tabsArray.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        targetIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
        break;
      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        targetIndex = tabsArray.length - 1;
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.handleTabClick(event);
        return;
      default:
        return;
    }

    tabsArray[targetIndex].focus();
    this.switchTab(tabsArray[targetIndex], tabsArray[targetIndex].dataset.tab);
  }

  switchTab(activeTab, targetPanel) {
    if (!activeTab || !targetPanel) {
      return;
    }

    const panel = this.querySelector(`[data-panel="${targetPanel}"]`);
    if (!panel) {
      return;
    }

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((p) => {
      const isActive = p === panel;
      p.classList.toggle('active', isActive);
      p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

customElements.define('product-info-tabs', ProductInfoTabs);
